import { useController } from 'react-hook-form';
import { IncField } from '../fields.types';
import DrawerFieldBase, {
  DrawerFieldBaseProps,
} from './drawer-field-base/drawer-field-base.component';

export type DrawerFieldProps = Omit<IncField<DrawerFieldBaseProps>, 'value'>;

const DrawerField = ({ name, ...rest }: DrawerFieldProps) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name });

  return (
    <>
      <DrawerFieldBase
        error={error}
        value={field.value}
        {...rest}
        ref={field.ref}
      />
    </>
  );
};

export default DrawerField;
